import { Injectable, inject } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";

// The language the app renders. Only the bootstrap and EffectiveLanguageService set it: a user
// who switches language reloads the page (ADR-010), so components never redraw on a switch.
@Injectable({ providedIn: "root" })
export class ActiveLanguageService {
    private readonly transloco = inject(TranslocoService);

    /** Registers every lang code the app can switch to. Call before setActiveLanguage. */
    setAvailableLanguages(langs: string[]): void {
        this.transloco.setAvailableLangs(langs);
    }

    setActiveLanguage(lang: string): void {
        this.transloco.setActiveLang(lang);
    }
}
